import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import ScreenContainer from "../components/screen";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      return;
    }

    fetch(`${API_BASE_URL}/auth/verify-email?token=${token}`)
      .then((res) => {
        if (res.ok) {
          setStatus("success");
        } else {
          setStatus("error");
        }
      })
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <ScreenContainer>
      <section className="py-24 bg-white min-h-[50vh] flex items-center justify-center">
        <div className="max-w-md mx-auto text-center px-6">
          {status === "loading" && (
            <>
              <div className="w-16 h-16 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mx-auto mb-6"></div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                Verifying your email...
              </h2>
              <p className="text-gray-600">Please wait a moment.</p>
            </>
          )}

          {status === "success" && (
            <>
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                Email verified!
              </h2>
              <p className="text-gray-600 mb-8">
                Your email has been verified successfully. You can now log in to your account.
              </p>
              <Link
                to="/"
                className="bg-orange-500 text-white px-6 py-3 rounded-full hover:bg-orange-600 transition inline-block"
              >
                Go to homepage
              </Link>
            </>
          )}

          {status === "error" && (
            <>
              <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <svg className="w-8 h-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </div>
              <h2 className="text-2xl font-semibold text-gray-800 mb-4">
                Verification failed
              </h2>
              <p className="text-gray-600 mb-8">
                This verification link is invalid or has expired. Please request a new verification email from the app.
              </p>
              <Link
                to="/"
                className="bg-orange-500 text-white px-6 py-3 rounded-full hover:bg-orange-600 transition inline-block"
              >
                Go to homepage
              </Link>
            </>
          )}
        </div>
      </section>
    </ScreenContainer>
  );
}
